module.exports = __webpack_public_path__ + "static/media/20180905_105559.9df1e891.jpg";